// @flow

import * as React from 'react';
import { connect } from 'react-redux';
import TimelineEvent from './timeline-event';

export type TimelineEventData = {
  _id: string,
  timestamp: number,
  actor: string,
  target: string,
  action: string,
  data: {
    diff?: mixed,
    reason?: string
  }
};

// TODO: Refactor to use immutables

type Props = {
  data: Array<TimelineEventData>,
  users: Array<mixed> // users are immutable
};

const ActivityTimeline = ({ data, users }: Props) => {
  return (
    <div
      style={{
        position: 'relative',
        paddingLeft: 32
      }}
    >
      <div
        style={{
          position: 'absolute',
          top: 0,
          bottom: 0,
          left: 15,
          width: 2,
          backgroundColor: '#e0e0e0'
        }}
      />
      {data.map((event) => (
        <TimelineEvent key={event._id} data={event} users={users} />
      ))}
    </div>
  );
};

export default connect(({ users: { list: users } }) => ({ users }))(
  ActivityTimeline
);